module.exports = __webpack_public_path__ + "static/img/05.c332aee3.png";